<div class="settlement-agreement-box {{agreement.agreementStatus}}" data-cy="settlement-agreement-detail">
  <div class="settlement-agreement-box-title" data-cy="settlement-agreement-box-title">{{agreement.title}}</div>
  <div class="settlement-agreement-table">
    <app-settlement-agreement-table
      [settlementTableData]="$safeNavigationMigration(agreement?.data?.tableData)">
    </app-settlement-agreement-table>
  </div>
  <div class="settlement-agreement-table-total">
    <div class="settlement-agreement-table-total-text">{{LABEL_TOTAL}} {{financialNumberText(agreement.data.materialsTotalGrossCost, agreement.data.currency) | undefinedValue}}</div>
    <div class="settlement-agreement-table-total-text">{{LABEL_TOTAL}} {{financialNumberText(agreement.data.teMinutesTotalCost, agreement.data.currency) | undefinedValue}}</div>
  </div>
  <div class="settlement-agreement-separator"></div>
  <div class="settlement-agreement-table-total contact-manager-total-gross-amount">
    <div class="settlement-agreement-contact-manager">
      <div class="settlement-agreement-label contact-manager"
      data-cy="settlement-agreement-detail-contact-manager-label">{{LABEL_CONTACT_MANAGER}}</div>
      <div class="settlement-agreement-value contact-manager"
      data-cy="settlement-agreement-detail-contact-manager-value">{{agreement.data.contactManager | undefinedValue}}</div>
    </div>
    <div class="settlement-agreement-total-gross-amount">
      <div class="settlement-agreement-label total-gross-amount"
      data-cy="settlement-agreement-detail-agreement-total-label">{{AGREEMENT_TOTAL_GROSS_AMOUNT}}</div>
      <div class="settlement-agreement-value total-gross-amount"
      data-cy="settlement-agreement-detail-agreement-total-value">{{financialNumberText(agreement.data.settlementTotalCost, agreement.data.currency) | undefinedValue}}</div>
    </div>
  </div>
</div>

@if (isRejected) {
  <div class="agreement-rejection">
    <app-settlement-reject-motivation
      [agreementDecision]="agreement.data.decision">
    </app-settlement-reject-motivation>
  </div>
}

@if (isAccepted) {
  <div class="agreement-acceptance">
    <app-settlement-accept-comment
      [acceptanceComment]="agreement.data.decision">
    </app-settlement-accept-comment>
  </div>
}

